"use client";

import { productReferences } from "@/cms/lib/productCards";
import { useProductTeasers } from "@/hooks/useProductTeasers";

export function ProductCardBlock({ data }: { data: unknown }) {
  const references = productReferences(data);
  const { products, isPending, isError } = useProductTeasers(
    references.map((p) => p.productId),
  );
  return (
    <div
      data-product-id={references[0]?.productId}
      className="rounded border bg-gray-50 p-3"
    >
      <div className="text-xs uppercase opacity-60">Product Card</div>
      {isError ? (
        <p role="status" className="text-sm text-gray-500">
          Could not load product images.
        </p>
      ) : null}
      {references.length ? (
        <div className="space-y-2">
          {references.map((reference, index) => {
            const product = products[reference.productId];
            const image = product?.heroAsset?.url || product?.hero_image;
            return (
              <div
                key={`${reference.productId}-${index}`}
                className="flex items-center gap-3 rounded border border-gray-100 bg-white px-3 py-2"
              >
                {image ? (
                  // eslint-disable-next-line @next/next/no-img-element
                  <img
                    src={image}
                    alt=""
                    className="h-12 w-12 rounded border border-gray-100 object-cover"
                    loading="lazy"
                  />
                ) : (
                  <div
                    className="h-12 w-12 shrink-0 rounded border border-gray-100 bg-gray-50"
                    aria-label={isPending ? "Loading image" : "No image"}
                  />
                )}
                <div className="font-semibold">
                  {product?.part_number ||
                    reference.partNumber ||
                    reference.productId}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-sm text-gray-500">No product selected</div>
      )}
    </div>
  );
}
